import {
  createBrowserRouter,
  createRoutesFromElements,
  Route,
  RouterProvider,
  Outlet,
  useLocation,
} from "react-router-dom";

import Home from "../components/Home";
import SignupForm from "../components/auth/Signup";
import Navbar from "../ui/navbar/Navbar";
import OTPVerification from "../components/auth/Verification";
import Login from "../components/auth/Login";
import DriverSignupPage from "../components/driver/DriverSignup";
import PaymentRedirectPage from "components/payment/PaystackRedirect";
import PaymentPage from "components/payment/Paystack";
import PaymentCancelled from "components/payment/PaystackCancelled";
import PaymentSuccess from "components/payment/success";
import WalletPage from "components/wallet/Wallet";
import DashboardRoutes from "./dashboardRouter";
import AccessDenied from "components/AccessDenied";
import RiderSignupLanding from "ui/landingPage/Rider";
import AboutUs from "components/company/AboutUs";
import DriverInformation from "../components/driver/DriverInformation";

const Root = () => {
  const location = useLocation();

  const isDashboard = location.pathname.startsWith("/dashboard");

  return (
    <div
      className="bg-background"
      style={{ display: "flex", flexDirection: "column", minHeight: "100vh" }}
    >
      {!isDashboard && (
        <>
          <Navbar />
        </>
      )}

      <div style={{ flex: 1 }}>
        <Outlet />
      </div>
      {/* <div>
				<Footer />
			</div> */}
    </div>
  );
};

let router = createBrowserRouter(
  createRoutesFromElements(
    <Route path="/" element={<Root />}>
      {/* other routes here */}
      <Route path="/" element={<Home />} />
      <Route path="/signup" element={<SignupForm />} />
      <Route path="/auth/verification/:type" element={<OTPVerification />} />
      <Route path="/about" element={<AboutUs />} />
      <Route path="/login" element={<Login />} />
      <Route path="/rider" element={<RiderSignupLanding />} />
      <Route path="/rider/auth" element={<DriverSignupPage />} />
      <Route path="/driver/signup" element={<DriverSignupPage />} />
      <Route path="/driver/info" element={<DriverInformation />} />
      <Route path="/wallet" element={<WalletPage />} />
      <Route path="/payment/redirect" element={<PaymentRedirectPage />} />
      <Route
        path="/payment/paystack/:ref/:accessCode/:id/:purpose"
        element={<PaymentPage />}
      />
      <Route
        path="/payment/cancelled/:id/:paymentNumber/:purpose"
        element={<PaymentCancelled />}
      />
      <Route
        path="/payment/failed/:id/:paymentNumber/:purpose"
        element={<PaymentCancelled />}
      />
      <Route
        path="/payment/success/:id/:paymentNumber/:purpose"
        element={<PaymentSuccess />}
      />
      <Route
        path="/payment/success/:paymentNumber/:purpose"
        element={<PaymentSuccess />}
      />
      {/* dashboard routes */}
      <Route path="/access-denied" element={<AccessDenied />} />
      <Route path="*" element={<div>Page not found</div>} />

      {DashboardRoutes}
    </Route>
  )
);

export default function RouterItem() {
  console.log(router);
  return <RouterProvider router={router} />;
}
